var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19 15C19 17.2 17.2 19 15 19H5C2.8 19 1 17.2 1 15C1 13.2 2.2 11.6 4 11.1C3.4 10.4 3 9.5 3 8.5C3 6.6 4.6 5 6.5 5C7.1 5 7.7 5.1 8.2 5.4C9 3.4 11 2 13.5 2C16.5 2 19 4.5 19 7.5C19 8 18.9 8.5 18.8 9C20.6 9.5 22 11.1 22 13C22 15.2 20.2 17 18 17H17",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L7 13H10V18H14V13H17L12 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.77a1ad09f2b7ec61713793b291e0aa5f.svg";
export { ForwardRef as ReactComponent };